module.exports = __webpack_public_path__ + "img/3-2.9b1e384a.jpg";